import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var LogCalendar = require("components/reading/logs/LogCalendar");
var ItemHeader = require("components/data/subjects/shared/ItemHeader");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textVariety", "textID", "userIDs"
	);

	conditions.timeKey = "log_date";

	return conditions;
}

@connect(
	(state, props) => ({
		logs: ReadingSelectors.logs({
			state, conditions: propsToConditions(props)
		}),
		loading: ReadingSelectors.isLoadingLogs({ state }),
	}),
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID")
				var actionFunction = ReadingActions.fetchLogs
				var options = { cache: true }
				return new Promise(function (resolve, reject) {
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (results) => {
						resolve(results);
					})
				}).catch(() => console.log("Logs failed to load"))
			} else {
				return dispatch(ReadingActions.fetchLogs({
					conditions: propsToConditions(props),
					cache: true
				}));
			}
		}
	})
)
@providePopulateData()
class DataLogCalendars extends React.Component {
	constructor(props) {
		super();
		autobind(this);

	}

	render() {
		var calendarLogsDisplay = []
		var studentsWithoutLogs = []

		_.each(this.props.userIDs, (studentID) => {
			var logs = _.where(this.props.logs, { user_id: studentID });
			if (logs.length > 0) {
				calendarLogsDisplay.push(
					<div key={ studentID }>
						<ItemHeader studentID={ studentID } pageBreak />
						<LogCalendar logs={ logs } key={ studentID } />					
					</div>
				)
			} else {
				studentsWithoutLogs.push(studentID)
			}
		});
		if (studentsWithoutLogs.length > 0) {
			var noLogs = <NoActivityBlock userIDs={ studentsWithoutLogs } contentType="Reading Log Calendars" />
		}
		var display = (
			<div>
				{ calendarLogsDisplay }
				{ noLogs }
			</div>
		)

		return (
			<div className="dataLogCalendars">
				{ display }
			</div>
		)
	}
}
DataLogCalendars.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showFullData: PropTypes.bool,

	// Data from @connect
	loading: PropTypes.bool,
	logs: PropTypes.array,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataLogCalendars;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataLogCalendars.js